export class CreatePaRequestListDto {
    dept: number;
    year: number;
    ssn: string;
    itemCode: number;
    itemName: string;
    buCd: number;
    biz: string;
    mainSampleCd: string;
    managementFactoryCd: string;
    managementFactory: string;
    branchFactoryCd: string;
    branchFactory: string;
    vendorCd: number;
    vendor: string;
    originalOrderProcessTarget: string;
    originalOrderProcessDone: string;
    originalPh: string;
    originalPublish: string;
    originalTrnsptMthd: string;
    originalWh: string;
    originalDl: string;
    originalPlanQty: number;
    originalUpdateDate: string;
    originalOrderPlanNumber: number;
    requestId: string;
    requestClassification: string;
    requestType: string;
    requestColor: string;
    requestWh: string;
    requestDl: string;
    requestPlanQty: string;
    requestTrnsptMthd: string;
    requestRequestDateJst: string;
    requestRequestUser: string;
    requestComment: string;
    requestSalesRankOfBizAtLastWeek: string;
    requestSalesRankOfDivAtLastWeek: string;
    answerDlJst: string;
    factoryAnswerAgrFlg: string;
    factoryAnswerJdgRslt: string;
    factoryAnswerPsblPh: string;
    factoryAnswerPsblWhShip: string;
    factoryAnswerPsblWhAir: string;
    factoryAnswerMinQty: string;
    factoryAnswerPsblQty: string;
    factoryAnswerYarnDl: string;
    factoryAnswerFabricDl: string;
    factoryAnswerColorDl: string;
    factoryAnswerTrimDl: string;
    factoryAnswerPoDl: string;
    factoryAnswerExf: string;
    factoryAnswerBdExf: string;
    factoryAnswerPoExf: string;
    factoryAnswerPrdMonth: string;
    factoryAnswerNgReason1: string;
    factoryAnswerNgReason2: string;
    factoryAnswerFreeComment: string;
    factoryAnswerAnswerUser: string;
    factoryAnswerAnswerDate: string;
    orderDecisionDecision: string;
    orderDecisionOrderQty: string;
    orderDecisionAirUse: string;
    dlYarnOrderQty: number;
    dlYarnOrderNumber: number;
    dlYarnPlan: string;
    dlYarnActual: string;
    dlFabricOrderQty: number;
    dlFabricOrderNumber: number;
    dlFabricPlan: string;
    dlFabricActual: string;
    dlColorOrderQty: string;
    dlColorOrderNumber: number;
    dlColorPlan: string;
    dlColorActual: string;
    dlTrimOrderQty: number;
    dlTrimOrderNumber: number;
    dlTrimPlan: string;
    dlTrimActual: string;
    dlPoOrderQty: number;
    dlPoOrderNumber: number;
    dlPoPlan: string;
    dlPoActual: string;
    factoryAnswerJdgRsltFirstTime: string;
    factoryAnswerNgReason1FirstTime: string;
    factoryAnswerNgReason2FirstTime: string;
    factoryAnswerFreeCommentFirstTime: string;
    constructor(
        dept: number,
        year: number,
        ssn: string,
        itemCode: number,
        itemName: string,
        buCd: number,
        biz: string,
        mainSampleCd: string,
        managementFactoryCd: string,
        managementFactory: string,
        branchFactoryCd: string,
        branchFactory: string,
        vendorCd: number,
        vendor: string,
        originalOrderProcessTarget: string,
        originalOrderProcessDone: string,
        originalPh: string,
        originalPublish: string,
        originalTrnsptMthd: string,
        originalWh: string,
        originalDl: string,
        originalPlanQty: number,
        originalUpdateDate: string,
        originalOrderPlanNumber: number,
        requestId: string,
        requestClassification: string,
        requestType: string,
        requestColor: string,
        requestWh: string,
        requestDl: string,
        requestPlanQty: string,
        requestTrnsptMthd: string,
        requestRequestDateJst: string,
        requestRequestUser: string,
        requestComment: string,
        requestSalesRankOfBizAtLastWeek: string,
        requestSalesRankOfDivAtLastWeek: string,
        answerDlJst: string,
        factoryAnswerAgrFlg: string,
        factoryAnswerJdgRslt: string,
        factoryAnswerPsblPh: string,
        factoryAnswerPsblWhShip: string,
        factoryAnswerPsblWhAir: string,
        factoryAnswerMinQty: string,
        factoryAnswerPsblQty: string,
        factoryAnswerYarnDl: string,
        factoryAnswerFabricDl: string,
        factoryAnswerColorDl: string,
        factoryAnswerTrimDl: string,
        factoryAnswerPoDl: string,
        factoryAnswerExf: string,
        factoryAnswerBdExf: string,
        factoryAnswerPoExf: string,
        factoryAnswerPrdMonth: string,
        factoryAnswerNgReason1: string,
        factoryAnswerNgReason2: string,
        factoryAnswerFreeComment: string,
        factoryAnswerAnswerUser: string,
        factoryAnswerAnswerDate: string,
        orderDecisionDecision: string,
        orderDecisionOrderQty: string,
        orderDecisionAirUse: string,
        dlYarnOrderQty: number,
        dlYarnOrderNumber: number,
        dlYarnPlan: string,
        dlYarnActual: string,
        dlFabricOrderQty: number,
        dlFabricOrderNumber: number,
        dlFabricPlan: string,
        dlFabricActual: string,
        dlColorOrderQty: string,
        dlColorOrderNumber: number,
        dlColorPlan: string,
        dlColorActual: string,
        dlTrimOrderQty: number,
        dlTrimOrderNumber: number,
        dlTrimPlan: string,
        dlTrimActual: string,
        dlPoOrderQty: number,
        dlPoOrderNumber: number,
        dlPoPlan: string,
        dlPoActual: string,
        factoryAnswerJdgRsltFirstTime: string,
        factoryAnswerNgReason1FirstTime: string,
        factoryAnswerNgReason2FirstTime: string,
        factoryAnswerFreeCommentFirstTime: string,
    ) {
        this.dept = dept;
        this.year = year;
        this.ssn = ssn;
        this.itemCode = itemCode;
        this.itemName = itemName;
        this.buCd = buCd;
        this.biz = biz;
        this.mainSampleCd = mainSampleCd;
        this.managementFactoryCd = managementFactoryCd;
        this.managementFactory = managementFactory;
        this.branchFactoryCd = branchFactoryCd;
        this.branchFactory = branchFactory;
        this.vendorCd = vendorCd;
        this.vendor = vendor;
        this.originalOrderProcessTarget = originalOrderProcessTarget;
        this.originalOrderProcessDone = originalOrderProcessDone;
        this.originalPh = originalPh;
        this.originalPublish = originalPublish;
        this.originalTrnsptMthd = originalTrnsptMthd;
        this.originalWh = originalWh;
        this.originalDl = originalDl;
        this.originalPlanQty = originalPlanQty;
        this.originalUpdateDate = originalUpdateDate;
        this.originalOrderPlanNumber = originalOrderPlanNumber;
        this.requestId = requestId;
        this.requestClassification = requestClassification;
        this.requestType = requestType;
        this.requestColor = requestColor;
        this.requestWh = requestWh;
        this.requestDl = requestDl;
        this.requestPlanQty = requestPlanQty;
        this.requestTrnsptMthd = requestTrnsptMthd;
        this.requestRequestDateJst = requestRequestDateJst;
        this.requestRequestUser = requestRequestUser;
        this.requestComment = requestComment;
        this.requestSalesRankOfBizAtLastWeek = requestSalesRankOfBizAtLastWeek;
        this.requestSalesRankOfDivAtLastWeek = requestSalesRankOfDivAtLastWeek;
        this.answerDlJst = answerDlJst;
        this.factoryAnswerAgrFlg = factoryAnswerAgrFlg;
        this.factoryAnswerJdgRslt = factoryAnswerJdgRslt;
        this.factoryAnswerPsblPh = factoryAnswerPsblPh;
        this.factoryAnswerPsblWhShip = factoryAnswerPsblWhShip;
        this.factoryAnswerPsblWhAir = factoryAnswerPsblWhAir;
        this.factoryAnswerMinQty = factoryAnswerMinQty;
        this.factoryAnswerPsblQty = factoryAnswerPsblQty;
        this.factoryAnswerYarnDl = factoryAnswerYarnDl;
        this.factoryAnswerFabricDl = factoryAnswerFabricDl;
        this.factoryAnswerColorDl = factoryAnswerColorDl;
        this.factoryAnswerTrimDl = factoryAnswerTrimDl;
        this.factoryAnswerPoDl = factoryAnswerPoDl;
        this.factoryAnswerExf = factoryAnswerExf;
        this.factoryAnswerBdExf = factoryAnswerBdExf;
        this.factoryAnswerPoExf = factoryAnswerPoExf;
        this.factoryAnswerPrdMonth = factoryAnswerPrdMonth;
        this.factoryAnswerNgReason1 = factoryAnswerNgReason1;
        this.factoryAnswerNgReason2 = factoryAnswerNgReason2;
        this.factoryAnswerFreeComment = factoryAnswerFreeComment;
        this.factoryAnswerAnswerUser = factoryAnswerAnswerUser;
        this.factoryAnswerAnswerDate = factoryAnswerAnswerDate;
        this.orderDecisionDecision = orderDecisionDecision;
        this.orderDecisionOrderQty = orderDecisionOrderQty;
        this.orderDecisionAirUse = orderDecisionAirUse;
        this.dlYarnOrderQty = dlYarnOrderQty;
        this.dlYarnOrderNumber = dlYarnOrderNumber;
        this.dlYarnPlan = dlYarnPlan;
        this.dlYarnActual = dlYarnActual;
        this.dlFabricOrderQty = dlFabricOrderQty;
        this.dlFabricOrderNumber = dlFabricOrderNumber;
        this.dlFabricPlan = dlFabricPlan;
        this.dlFabricActual = dlFabricActual;
        this.dlColorOrderQty = dlColorOrderQty;
        this.dlColorOrderNumber = dlColorOrderNumber;
        this.dlColorPlan = dlColorPlan;
        this.dlColorActual = dlColorActual;
        this.dlTrimOrderQty = dlTrimOrderQty;
        this.dlTrimOrderNumber = dlTrimOrderNumber;
        this.dlTrimPlan = dlTrimPlan;
        this.dlTrimActual = dlTrimActual;
        this.dlPoOrderQty = dlPoOrderQty;
        this.dlPoOrderNumber = dlPoOrderNumber;
        this.dlPoPlan = dlPoPlan;
        this.dlPoActual = dlPoActual;
        this.factoryAnswerJdgRsltFirstTime = factoryAnswerJdgRsltFirstTime;
        this.factoryAnswerNgReason1FirstTime = factoryAnswerNgReason1FirstTime;
        this.factoryAnswerNgReason2FirstTime = factoryAnswerNgReason2FirstTime;
        this.factoryAnswerFreeCommentFirstTime = factoryAnswerFreeCommentFirstTime;
    }
}
